import { DEFAULT_API_KEY } from './datiq-map-model';
import { inject, Injectable } from '@angular/core';

import { LazyMapsAPIConfig } from './google-maps-api-config.interface';
import { MC_MAP_GOOGLE_API_KEY } from '@dat/iq-mc-utils';


@Injectable()
export class GoogleMapsApiConfig implements LazyMapsAPIConfig {
    public apiKey: string;

    private _googleApiKey: string = inject<string>(MC_MAP_GOOGLE_API_KEY);

    constructor() {
        this.apiKey = !!this._googleApiKey?.length
            ? this._googleApiKey
            : DEFAULT_API_KEY;
    }
}
